import React from 'react';

class Footer extends React.Component {

  render() {
    return (
      <footer className="footer">
        <div className="container text-center">
          <small className="copyright">Copyright &copy; {(new Date()).getFullYear()} Richard Gebbie</small>
        </div>
      </footer>
    );
  }
}

export default Footer;